import { Summary } from '../services/purchaseApi.types';
import {
  CapitalizedTransferType,
  TransferType,
  TransferTypeFriendly
} from '../types/transfer.types';

export function getTransferType(transfer: Summary['transfer']): string {
  if (transfer === undefined) {
    return 'transfer';
  }

  return transfer.deliveryType;
}

export function getTransferTypeNormalized(transfer: Summary['transfer']): TransferType {
  const transferType = getTransferType(transfer).toLowerCase();

  if (transferType.includes('delivery')) {
    return 'delivery';
  } else if (transferType.includes('pickup')) {
    return 'pickup';
  } else {
    return 'transfer';
  }
}

export function normalizeActivityType(activityType: string | undefined): TransferType {
  const normalized = (activityType ?? '').toLowerCase();

  if (normalized.includes('delivery')) {
    return 'delivery';
  } else if (normalized.includes('pickup')) {
    return 'pickup';
  } else {
    return 'transfer';
  }
}

export function getTransferTypeFriendly(transfer: Summary['transfer']): TransferTypeFriendly {
  const normalizedTransferType = getTransferTypeNormalized(transfer);

  switch (normalizedTransferType) {
    case 'delivery':
      return 'delivery';
    case 'pickup':
      return 'pick-up';
    default:
      return 'transfer';
  }
}

export function getTransferTypeFriendlyCapitalized(
  transfer: Summary['transfer']
): CapitalizedTransferType {
  const normalizedTransferType = getTransferTypeNormalized(transfer);

  switch (normalizedTransferType) {
    case 'delivery':
      return 'Delivery';
    case 'pickup':
      return 'Pick-up';
    default:
      return 'Transfer';
  }
}
